//
import AccountModel from '@/models/Accounting/AccAccount'
import { RFormFields } from '@/components/reusable_components/next'
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
export default props => new RFormFields(
	{
	    name: 'acc_account_id',
	    type: 'autocomplete-model',
	    flex: {
	    	'sm6': true,
	    },
	    props: {
	        itemText: 'name',
	        itemValue: 'id',
	        label: 'Cuenta',
	        model: AccountModel,
	        noObject: true,
	        rules: [ RequiredRule ],
	    },
	    trigger: props.acc_account_trigger,
	},
	{
	    name: 'details_account_conciliation',
	    type: 'table-field',
	    flex: {
	    	'd-grid': true,
	    	'xs12': true,
	    },
	    props: {
	    	checkboxColor: props.acc_details_account_conciliation_checkbox_color,
	    	headers: [
	    		{
	    			text: '#',
	    			value: 'id',
	    			width: '5%',
	    		},
	    		{
	    			text: 'nombre',
	    			value: ({ code, comment }) => `${code} - ${comment}`,
	    		},
	    		{
	    			text: 'debe',
	    			value: 'debit_account',
	    		},
	    		{
	    			text: 'monto',
	    			value: 'debit',
	    			align: 'right',
	    			format: 'currency',
	    		},
	    		{
	    			text: 'haber',
	    			value: 'credit_account',
	    		},
	    		{
	    			text: 'monto',
	    			value: 'credit',
	    			align: 'right',
	    			format: 'currency',
	    		},
	    	],
	    	noDataText: 'Sin asientos contables',
	    	selectedKey: 'multi_suggest_id',
	        toolbarTitle: 'Detalles de asientos contables'
	    },
	},
)
